import React from 'react';
import Popup from "reactjs-popup";
import {LIMIT} from "ubs-framework/v2/common/constant";
import {dayPipe} from "ubs-framework/v2/common/function";

const Time = React.memo((props) => {
    return (
        <Popup
            trigger={open => (
                <p className="u_activity-date">{dayPipe(props.createdAt, 'comment')}</p>
            )}
            arrow={true}
            on={['hover', 'focus']}
            position="bottom center"
            closeOnDocumentClick
            offsetY={3}
            repositionOnResize
            keepTooltipInside={true}
            mouseEnterDelay={LIMIT.TOOLTIP_DELAY}
            className="u_tooltip"
        >
            <span>{dayPipe(props.createdAt)}</span>
        </Popup>
    );
});

export default Time;
